module.exports = (__webpack_require__(45330))(296540);